// ------------------------------------------
// モーダル・メニューのフォーカス制御
// ------------------------------------------
class FocusTrap {
  constructor(container) {
    this.container = container;
    this.opener = null;
    this.onKeydown = this.onKeydown.bind(this);
  }

  focusables() {
    const selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.from(this.container.querySelectorAll(selector)).filter((el) => {
      if (el.closest('[aria-hidden="true"]') && el.closest('[aria-hidden="true"]') !== this.container) return false;
      return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  activate(first) {
    this.opener = document.activeElement;
    document.addEventListener('keydown', this.onKeydown);
    const target = first || this.focusables()[0];
    if (target) target.focus({ preventScroll: true });
  }

  deactivate() {
    document.removeEventListener('keydown', this.onKeydown);
    if (this.opener && typeof this.opener.focus === 'function') {
      this.opener.focus({ preventScroll: true });
    }
    this.opener = null;
  }

  onKeydown(e) {
    if (e.key !== 'Tab') return;
    const items = this.focusables();
    if (items.length === 0) {
      e.preventDefault();
      return;
    }
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;

    if (e.shiftKey && (active === first || !this.container.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !this.container.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  }
}
